import { environment } from "../../../../../environments/environment";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { User } from "../../../../core/models/user";
import { loginI } from "app/core/models/login";
import { Provider } from "app/core/models/provider";
import { ResponseI } from "app/core/models/response";
import { Socket } from "ngx-socket-io";
import { UsersService } from "app/modules/main/services/users/users.service";
import { th } from "date-fns/locale";

const apiUrl = environment.API_URI;

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    private http: HttpClient,
    private socket: Socket,
    private usersService: UsersService
  ) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem("user_token");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  hotelId = localStorage.getItem("hotel_id");
  userType;
  userId;

  login(loginData: any): Observable<any> {
    try {
      console.log(loginData);
      return this.http.post(`${apiUrl}/api/auth/signin`, loginData, {
        headers: this.getHeaders(),
      });
    } catch (error) {
      console.log(error);
    }
  }

  forgotPassword(email): Observable<loginI> {
    try {
      //this.http.get<loginI>(`${apiUrl}/user-admin/loxst-pass/${email}`, this.httpOptions);
      return this.http.get<loginI>(`${apiUrl}/auth/lost-pass/${email}`);
    } catch (error) {
      console.log(error);
    }
  }

  accountActivate(token): Observable<loginI> {
    try {
      return this.http.get<loginI>(`${apiUrl}/user-admin/activate/${token}`, {
        headers: this.getHeaders(),
      });
    } catch (error) {
      console.log(error);
    }
  }

  resetPassword(email, password): any {
    console.log(email, password);
    try {
      return this.http.put(`${apiUrl}/auth/user/${email}/${password}`, "");
    } catch (error) {
      console.log(error);
    }
  }

  registerUser(user): Observable<User> {
    try {
      return this.http.post<User>(`${apiUrl}/user-admin/register`, user, {
        headers: this.getHeaders(),
      });
    } catch (error) {
      console.log(error);
    }
  }

  registerFinalUser(user): Observable<User> {
    try {
      return this.http.post<User>(`${apiUrl}/final-user`, user, {
        headers: this.getHeaders(),
      });
    } catch (error) {
      console.log(error);
    }
  }

  getUserToken(token: string) {
    try {
      return this.http.get(`${apiUrl}/final-user/find/${token}`, {
        headers: this.getHeaders(),
      });
    } catch (error) {
      console.log(error);
    }
  }

  updateUser(id: number, user: any): Observable<User> {
    try {
      return this.http.put<User>(`${apiUrl}/final-user/${id}`, user, {
        headers: this.getHeaders(),
      });
    } catch (error) {
      console.log(error);
    }
  }

  providerSignup(
    provider,
    //categories: string
  ) {
    try {
      const userData = {
        email: provider.email,
        name: provider.name,
        last_name: provider.last_name,
        password: provider.password,
        status: 1,
        telephone: provider.telephone,
        address: provider.address,
        city: provider.city,
        identification: provider.cedula,
        user_role_id: 1,
        user_type_id: 1,
        natural_person: 1,
      }
      return this.http.post(`${apiUrl}/api/users`, userData, {headers: this.getHeaders()});
    } catch (error) {
      console.log("error en el registro");
    }
  }

  companySignup(
    company
    //categories: string
  ) {
    try {
      const companyData = {
        name: company.company_name,
        nit: company.nit,
      }
      return this.http.post(`${apiUrl}/api/companies`, companyData, {headers: this.getHeaders()});
    } catch (error) {
      console.log("error en el registro");
    }
  }

  companyUserSignup(provider, createdCompany) {
    console.log(provider);
    try {
    const userData = {
      name: provider.manager_name,
      last_name: provider.manager_last_name,
      email: provider.email,
      password: provider.password,
      address: provider.address,
      identification: provider.nit,
      city: provider.city,
      telephone: provider.telephone,
      status: 1,
      user_role_id: 1,
      user_type_id: 1,
      company_id: createdCompany.company_id,
      natural_person: 0,
    }
    console.log(userData);
    return this.http.post(`${apiUrl}/api/auth/signup`, userData, {headers: this.getHeaders()})
  } catch (error) {
    console.log("error en el registro");
  }
  }


  mailConfirmation(email) {
    try {
      return this.http.get(`${apiUrl}/aws-ses/LostPass/${email}`);
    } catch (error) {
      console.log(error);
    }
  }

  Categoriesprovider(): Observable<ResponseI> {
    try {
      return this.http.get<ResponseI>(`${apiUrl}/category-provider`);
    } catch (error) {
      console.log("error en el registro");
    }
  }

  establishmentCategories() {
    try {
      return this.http.get(`${apiUrl}/api/establishment_types`, { headers: this.getHeaders() });
    } catch (err) {
      console.log(err);
    }
  }

  getOneCategoryEstablishment(id: number): any {
    return this.http.get(`${apiUrl}/category-establishment/${id}`);
  }

  createSubCategoryProvider(sub: any): any {
    try {
      return this.http.post(`${apiUrl}/sub-category-provider`, sub);
    } catch (err) {
      console.log("error", err);
    }
  }

  getUser(email, password) {
    try {
      console.log(password);
      return this.http.put(`${apiUrl}/auth/user/${email}/${password}`, "");
    } catch (error) {
      console.log(error);
    }
  }

  getEstablishmentByUserId(id) {
    try {
      return this.http.get(`${apiUrl}/api/establishments/users/${id}`, {
        headers: this.getHeaders(),
      });
    } catch (error) {
      console.log(error);
    }
  }
}
